<app-layout-dialogheader1 [title]="title" [titlesub]="titlesub" mat-dialog-title>
</app-layout-dialogheader1>

<mat-dialog-content>
  <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
  <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
  <div class="container-fluid container-filter">
    <div class="row">
      <div class="col" *ngIf="showsitelist">
        <h4>By Site</h4>
        <!--  <input type="checkbox"(click)="selectAll1(checkAll1.checked, sites_list)" #checkAll1> -->
        <!-- <mat-selection-list #sites_list [(ngModel)]="dbFilter.sites" (ngModelChange)="onSiteChange($event)"> -->
        <app-select-check-all [select]="sites_list"></app-select-check-all>
        <perfect-scrollbar class="list-perfect-scrollbar">
          <mat-selection-list #sites_list [(ngModel)]="dbFilter.filterGet(filterColumn.site_id).selected" >
            <mat-list-option *ngFor="let item of dbFilter.filterGet(filterColumn.site_id).items" [value]="item">
              {{item.viewname}}
            </mat-list-option>
          </mat-selection-list>
        </perfect-scrollbar>

        <!--         <button mat-raised-button type="button" (click)="onSiteChange()"
          class="btn btn-sm btn-success mr-2">Apply</button>
        <button mat-raised-button class="btn btn-sm">Cancel</button> -->
      </div>
      <div class="col">
        <h4>By Issue Type</h4>
        <app-select-check-all [select]="issuetype"></app-select-check-all>
        <perfect-scrollbar class="list-perfect-scrollbar">
          <mat-selection-list #issuetype dense [(ngModel)]="dbFilter.filterGet(filterColumn.issue_type).selected">
            <mat-list-option *ngFor="let item of dbFilter.filterGet(filterColumn.issue_type).items" [value]="item">
              {{item.viewname}}
            </mat-list-option>
          </mat-selection-list>
        </perfect-scrollbar>
      </div>
      <div class="col">
        <h4>By Relevance</h4>
        <app-select-check-all [select]="relevancetype"></app-select-check-all>
        <perfect-scrollbar class="list-perfect-scrollbar">
          <mat-selection-list #relevancetype dense [(ngModel)]="dbFilter.filterGet(filterColumn.relevance).selected" multiple>
            <mat-list-option *ngFor="let item of dbFilter.filterGet(filterColumn.relevance).items" [value]="item">
              {{item.viewname}}
            </mat-list-option>
          </mat-selection-list>
        </perfect-scrollbar>

      </div>
      <div class="col" *ngIf="showmodulefilter">
        <h4>By Manufacturer</h4>
        <app-select-check-all [select]="brandtype"></app-select-check-all>
        <perfect-scrollbar class="list-perfect-scrollbar">
          <mat-selection-list #brandtype dense [(ngModel)]="dbFilter.filterGet(filterColumn.panel_brand).selected">
            <mat-list-option *ngFor="let item of dbFilter.filterGet(filterColumn.panel_brand).items" [value]="item">
              {{item.viewname}}
            </mat-list-option>
          </mat-selection-list>
        </perfect-scrollbar>

      </div>
      <div class="col" *ngIf="showmodulefilter">
        <h4>By Module</h4>
        <app-select-check-all [select]="moduletype"></app-select-check-all>
        <perfect-scrollbar class="list-perfect-scrollbar">

        <mat-selection-list #moduletype dense [(ngModel)]="dbFilter.filterGet(filterColumn.panel_model).selected">
          <mat-list-option *ngFor="let item of dbFilter.filterGet(filterColumn.panel_model).items" [value]="item">
            {{item.viewname}}
          </mat-list-option>
        </mat-selection-list>
      </perfect-scrollbar>
      </div>


    </div>
  </div>


</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button (click)="resetall()" class="btn btn-primary pull-right">Reset Filter</button>
    <button mat-raised-button mat-dialog-close type="button" (click)="filterBySelection_click()"
    class="btn btn-success pull-right">Apply & close</button>  
  <button mat-button type="button" (click)="filterBySelection_click(true)"
    class="btn btn-success pull-right">Apply</button>    
  <button mat-raised-button mat-dialog-close class="btn pull-right">Close</button>
</mat-dialog-actions>

<!-- <div mat-dialog-actions style="width:100%;" class="justify-content-end mat-dialog-actions">
  <button mat-raised-button (click)="resetall()" class="btn btn-primary pull-right">Reset Filter</button>
  <button mat-raised-button type="button" (click)="filterBySelection_click()"
    class="btn btn-success pull-right">Ok</button>
  <button mat-raised-button mat-dialog-close class="btn pull-right">Close</button>
</div> -->